<div class="vectare-transport mt-5" style="border:1px solid lightgrey; padding:10px; display:inline-block; min-width:900px">
  <h3>{{ 'SB_Vectare_Transport' | translate }}</h3>

  <sb-loading [hasLoaded]="!isLoading"></sb-loading>

  @if (!isLoading) {
    <div class="vectare-transport__section">
      <!-- sb-on-off-switch renders its state from isChecked, not model, so both are bound. -->
      <sb-on-off-switch
        [(model)]="isEnabled"
        [isChecked]="isEnabled"
        [label]="'SB_Enable_Vectare_Integration' | translate"
        id="vectareEnabled">
      </sb-on-off-switch>

      <p class="vectare-transport__note">{{ 'SB_Vectare_Disable_Note' | translate }}</p>
    </div>

    <div class="vectare-transport__section">
      <div class="vectare-transport__field">
        <label for="vectareUrl">
          {{ 'SB_Vectare_Url' | translate }}
          @if (isEnabled) {
            <span class="vectare-transport__required text-danger">*</span>
          }
        </label>
        <input
          id="vectareUrl"
          type="url"
          class="form-control"
          [(ngModel)]="vectareUrl"
          placeholder="https://school.vectare.eu/" />
        @if (isEnabled && !isUrlValid) {
          <p class="vectare-transport__error text-danger">{{ 'SB_Vectare_Url_Invalid' | translate }}</p>
        }
      </div>

      <div class="vectare-transport__field">
        <label for="owningPersonId">
          {{ 'SB_Vectare_Owning_Person' | translate }}
          @if (isEnabled) {
            <span class="vectare-transport__required text-danger">*</span>
          }
          <span class="vectare-transport__hint">&middot; {{ 'SB_Vectare_Owning_Person_Hint' | translate }}</span>
        </label>
        <select id="owningPersonId" class="form-control" [(ngModel)]="owningPersonId">
          <option [ngValue]="0">{{ 'SB_Select_A_Staff_Member' | translate }}</option>
          @for (option of owningPersonOptions; track option.personId) {
            <option [ngValue]="option.personId">{{ option.name }}</option>
          }
        </select>
        @if (owningPersonName) {
          <p class="vectare-transport__hint">
            {{ 'SB_Currently_Assigned_To' | translate }} <b>{{ owningPersonName }}</b>
          </p>
        }
        @if (isEnabled && owningPersonId === 0) {
          <p class="vectare-transport__error text-danger">{{ 'SB_Vectare_Owning_Person_Required' | translate }}</p>
        }
      </div>
    </div>

    <div class="vectare-transport__section">
      <h4>{{ 'SB_Manual_Sync' | translate }}</h4>
      <button type="button" class="btn btn-info" [disabled]="!canSync" (click)="syncNow()">
        {{ 'SB_Sync_Now' | translate }}
      </button>
      @if (syncRequested) {
        <p class="vectare-transport__success text-success">{{ 'SB_Sync_Requested' | translate }}</p>
      }
    </div>

    <div class="vectare-transport__section">
      <h4>{{ 'SB_Sync_History' | translate }}</h4>
      @if (history.length) {
        <table class="table table-striped table-condensed table-bordered">
          <thead>
            <tr>
              <th>{{ 'SB_Action' | translate }}</th>
              <th>{{ 'SB_Changed_By' | translate }}</th>
              <th>{{ 'SB_Date' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (item of history; track $index) {
              <tr>
                <td>{{ (item.isEnabled ? 'SB_Enabled' : 'SB_Disabled') | translate }}</td>
                <td>{{ item.changedByName }}</td>
                <td>{{ item.eventTimestampUtc | date: 'dd MMM yyyy, HH:mm' }}</td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <p class="vectare-transport__hint">{{ 'SB_No_History' | translate }}</p>
      }
    </div>

    @if (errorMessage) {
      <div class="alert alert-danger">
        {{ errorMessage | translate: errorMessageParameters }}
      </div>
    }

    <div class="vectare-transport__actions">
      <button type="button" class="btn btn-outline-warning" [disabled]="!isDirty" (click)="cancel()">
        {{ 'SB_Cancel' | translate }}
      </button>
      <button type="button" class="btn btn-success" [disabled]="!canSave" (click)="save()">
        {{ 'SB_Save' | translate }}
      </button>
    </div>
  }
</div>
